import { request } from './axios';
// 获取配置列表
export function getconfiglist(data = {}) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/GetExtJsonList`,
    data,
  });
}
// 获取配置详情
export function getconfigbyid(data = {}) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/GetConfigById`,
    data,
  });
}
// 获取小程序对应配置列表
export function getconfigbyappid(data = {}) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/GetExtJsonByAppId`,
    data,
  });
}
// 新建配置
export function addconfig(data = {}) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/AddExtJson`,
    data,
  });
}
// 修改配置
export function updateconfig(data = {}) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/UpdateExtJson`,
    data,
  });
}
// 删除配置
export function deleteconfig(data = {}) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/DeleteExtJson`,
    data,
  });
}
